var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('avue-crud',{attrs:{"data":_vm.data,"option":_vm.option},scopedSlots:_vm._u([{key:"menu",fn:function(scope){return [_c('el-button',{staticClass:"View"},[_vm._v("查看")]),_c('el-button',{staticClass:"View"},[_vm._v("下载")])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }